import React, { useEffect } from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Waypoint } from "react-waypoint";
import { useLocation } from "react-router-dom";

import {
  Heading,
  Box,
  Flex,
  Button,
  Text,
  UnorderedList,
  ListItem,
  Image,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet";

//data
import AreasOfWork from "./work";
import { Link, NavLink } from "react-router-dom";

//Image
const bg = require("../../assets/images/Logobg.jpeg");
const welcome1 = require("../../assets/images/Welcome2.jpeg");
const welcome2 = require("../../assets/images/Deep_water_FlowAssurance.jpeg");
const welcome3 = require("../../assets/images/Process_Engineering_Oil&gas.jpeg");
const Home = () => {
  let params = useLocation();
  useEffect(() => {
    if (params?.state?.id)
      document.querySelector(`${params.state.id}`).scrollIntoView(true);
    else window.scrollTo(0, 0);
  }, [params.state, useLocation().state]);

  return (
    <Flex flexDirection={"column"} alignItems={"center"}>
      <Helmet>
        <html lang="en" />

        <title>
          AKIA Flow Assurance | Flow Assurance & Process Engineering Consultancy
        </title>

        <meta
          name="description"
          content="AKIA Flow Assurance provides worldwide flow assurance and process engineering consultancy services for oil & gas, pipeline, and industrial systems. Expertise includes OLGA transient simulation, PIPESIM analysis, Aspen HYSYS modeling, pipeline hydraulics, surge analysis, hydrate and wax studies, multiphase flow modeling, and engineering support for operators, EPCs, and contractors."
        />

        <meta
          name="keywords"
          content="Flow Assurance Consultancy, Process Engineering Consultancy, OLGA Simulation Services, PIPESIM Analysis, Aspen HYSYS Modeling, Pipeline Hydraulics, Surge Analysis, Hydrate Study, Wax Deposition Analysis, Multiphase Flow Modeling, Oil and Gas Engineering, Pipeline Engineering, Transient Simulation, Steady State Simulation, Offshore Flow Assurance, Onshore Pipeline Studies, Engineering Consultancy Services, Process Simulation Services, EPC Engineering Support, Remote Engineering Consultancy, Global Engineering Services"
        />

        <meta name="author" content="AKIA Flow Assurance" />
        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="AKIA Flow Assurance | Flow Assurance & Process Engineering Consultancy"
        />

        <meta
          property="og:description"
          content="Specialized consultancy for flow assurance, transient analysis, pipeline hydraulics, process simulation, and engineering studies."
        />

        <link rel="canonical" href="https://akiaflowassurance.com/" />

        
      </Helmet>
      {/* Top Landing Section */}
      <Flex
        w={"100vw"}
        h={"100vh"}
        maxHeight={"1440px"}
        bg={`linear-gradient(rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.82))`}
        background={`linear-gradient(rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.82)), url(${bg})`}
        backgroundSize={"cover"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={"column"}
      >
        <Flex flexDirection={"column"} alignItems="center" px={"2rem"}>
          <Flex overflow={"hidden"} maxW={"100rem"} pos={"relative"}>
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain1").style.animation =
                "heading 1.5s ease-out")
              }
            >
              <Flex id="animateMain1">
                <Heading
                  flexShrink={"0"}
                  textTransform={"uppercase"}
                  fontSize={{ base: "3.0rem", "3sm": "3.5rem", lg: "4.5rem" }}
                  maxW={"100rem"}
                  color={"whiteAlpha.900"}
                  fontFamily={"Roboto Condensed, Lato, sans-serif"}
                  textAlign="center"

                  w={"100%"}
                >
                  AKIA  Flow Assurance
                </Heading>
                <Box flexShrink={"0"} bg={"whiteAlpha.900"} w={"100%"}></Box>
              </Flex>
            </Waypoint>
          </Flex>

          <Flex my={"1rem"} overflow={"hidden"} pos={"relative"}>
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain2").style.animation =
                "heading 1.5s ease-out")
              }
            >
              <Flex id="animateMain2">
                <Heading
                  textTransform={"uppercase"}
                  fontSize={{ base: "3.0rem", "3sm": "3.5rem", lg: "4.5rem" }}
                  textAlign={"center"}
                  fontWeight={"600"}
                  color={"whiteAlpha.900"}
                  fontFamily={"Roboto Condensed, Lato, sans-serif"}
                  pos={"relative"}
                  flexShrink={0}
                  width={"100%"}
                >
                  Flow Assurance Specialists
                </Heading>
                <Box flexShrink={"0"} bg={"whiteAlpha.900"} w={"100%"}></Box>
              </Flex>
            </Waypoint>
          </Flex>



          <Flex my={"1rem"} overflow={"hidden"} pos={"relative"}>
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain3").style.animation =
                "heading 1.5s ease-out")
              }
            >
              <Flex id="animateMain3">
                <Heading
                  textTransform={"uppercase"}
                  fontSize={{ base: "1.8rem", "3sm": "2.0rem", lg: "2.0rem" }}
                  textAlign={"center"}
                  fontWeight={"400"}
                  color={"whiteAlpha.900"}
                  fontFamily={"Roboto Condensed, Lato, sans-serif"}
                  pos={"relative"}
                  flexShrink={0}
                  width={"100%"}
                >
                  Simulation-driven studies for oil & gas production systems, pipelines, and utility networks.
                </Heading>
                <Box flexShrink={"0"} bg={"whiteAlpha.900"} w={"100%"}></Box>
              </Flex>
            </Waypoint>
          </Flex>

          <Waypoint
            onEnter={() =>
            (document.querySelector("#animate1").style.animation =
              "fadeUp 1.5s")
            }
          >
            <NavLink to={{ pathname: "/contact" }}>
              <Button
                id="animate1"
                bg={"#EA0F0F"}
                color={"whiteAlpha.900"}
                borderRadius={"0"}
                mt={"2rem"}
                fontSize="2rem"
                fontWeight={700}
                p={"2.5rem 5rem"}
                textTransform={"uppercase"}
                outline={"3px solid #EA0F0F"}
                outlineOffset={"5px"}
                transition={"all 0.3s ease"}
                _hover={{
                  outlineOffset: "0px",
                }}
              >
                Get in Touch
              </Button>
            </NavLink>
          </Waypoint>
        </Flex>

        <Flex
          transform={"translateY(4rem)"}
          cursor={"pointer"}
          w={"2.5rem"}
          h={"1.75rem"}
          bg={"rgba(255,255,255, 0.3)"}
          clipPath={"polygon(0 0, 50% 25%, 100% 0, 100% 75%, 50% 100%, 0 75%)"}
          justify={"center"}
          onClick={() => {
            document.querySelector("#welcomeSection").scrollIntoView({
              behavior: "smooth",
            });
          }}
        >
          <Box
            w={"2.5rem"}
            h={"2.25rem"}
            bg={"whiteAlpha.900"}
            animation={"arrow 1.75s infinite"}
          ></Box>
        </Flex>
      </Flex>

      {/* Next Section */}
      <Flex
        alignItems={"center"}
        flexDirection={"column"}
        px={"2rem"}
        py={"4rem"}
        maxW="1440px"
        w={"100%"}
      >

        <Flex
          fontSize={"2rem"}
          flexDirection={"column"}
          mt={{base:"","3sm":"4rem"}}
          width={"100%"}
        >
          <Flex flexDirection={{ base: "column-reverse", md: "row" }}>
            <Flex
              pt={{ base: "4rem", md: "2rem" }}
              flex={{ base: "0 1 50%" }}
              flexDirection={"column"}
              alignItems={{ base: "flex-start", md: "flex-start" }}
              textAlign={{ base: "justify", md: "left" }}
            >
              <Flex
                mb={"1.5rem"}
                overflow={"hidden"}
                pos={"relative"}
                width={"fit-content"}
              >
                <Waypoint
                  onEnter={() =>
                  (document.querySelector("#animate2").style.animation =
                    "heading 1.5s ")
                  }
                >
                  <Flex id="animate2">


                    <Heading
                      flexShrink={"0"}
                      textTransform={"uppercase"}
                      fontSize={{ base: "2.5rem", "3sm": "3.0rem" }}
                      w={"100%"}
                      pos="relative"
                      textAlign={"center"}
                    >
                      Who We Are
                    </Heading>

                    <Box flexShrink={"0"} bg={"black"} w={"100%"}></Box>
                  </Flex>
                </Waypoint>
              </Flex>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
              <Text
                fontSize={{ base: "1.8rem", xl: "2rem" }}
                maxW={{ base: "100%", md: "85%", lg: "80%" }}
                textAlign={{ base: "justify", md: "justify" }}
              >
                AKIA Flow Assurance is a specialist consultancy providing Flow Assurance and Process Engineering Support services for offshore and onshore oil & gas production systems, pipelines, and utility networks.<br/><br/>

We support operators, EPCs, and engineering contractors through simulation-driven studies, hydraulic analysis, and practical engineering solutions to address flow assurance, process, and system performance challenges worldwide.
              </Text>
            </Flex>
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animate3").style.animation =
                "fadeUp 1.5s")
              }
            >
              <Flex
                id="animate3"
                height={"350px"}
                flex={{
                  base: "0 1 150px",
                  "2sm": "0 1 190px",
                  "3sm": "0 1 400px",
                  md: "0 1 60%",
                }}
                bgImage={`url(${welcome1})`}
                mt={"4rem"}
                backgroundPosition="center"
                backgroundSize={{ base: "contain", md: "cover" }}
                backgroundRepeat="no-repeat"
                justify={"center"}
                alignItems={"center"}
                borderRadius="xl"
                boxShadow={"0 0 10px 10px rgba(0,0,0,0.08)"}
              ></Flex>
            </Waypoint>

          </Flex>


          <Flex
            fontSize={"2rem"}
            flexDirection={"column"}
            mt={"2rem"}
            width={"100%"}
          >
            <Flex flexDirection={{ base: "column-reverse", md: "row" }}>

              <Flex
                pt={{ base: "4rem", md: "2rem" }}
                flex={{ base: "0 1 50%" }}
                flexDirection={"column"}
                alignItems={{ base: "flex-start", md: "flex-start" }}
                textAlign={{ base: "justify", md: "left" }}
              >
                <Flex
                  mb={"1.5rem"}
                  overflow={"hidden"}
                  pos={"relative"}
                  width={"fit-content"}
                >
                  <Waypoint
                    onEnter={() =>
                    (document.querySelector("#animate4").style.animation =
                      "heading 1.5s ")
                    }
                  >
                    <Flex id="animate4">


                      <Heading
                        flexShrink={"0"}
                        textTransform={"uppercase"}
                        fontSize={{ base: "2.5rem", "3sm": "3.0rem" }}
                        w={"100%"}
                        pos="relative"
                        textAlign={ "center"}
                      >
                        Core expertise
                      </Heading>

                      <Box flexShrink={"0"} bg={"black"} w={"100%"}></Box>
                    </Flex>
                  </Waypoint>
                </Flex>
                <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
                
                <Text
                  fontSize={{ base: "1.8rem", xl: "2rem" }}
                  maxW={{ base: "100%", md: "85%", lg: "80%" }}
                  textAlign={{ base: "left", md: "justify" }}>

                  We specialize in understanding and managing flow related challenges in pipelines and production systems, including:<br />
                  <UnorderedList>
                    <ListItem>Multiphase Pipeline Hydraulic Analysis </ListItem>
                    <ListItem>Flow Regime Identification and Slugging Assessment</ListItem>
                    <ListItem>Pressure Drop and Liquid Holdup Prediction</ListItem>
                    <ListItem>Steady-state and Transient Flow Assurance Studies</ListItem>
                    <ListItem>Start-up, Shutdown, and Operability Analysis</ListItem>
                    <ListItem>Hydrate Formation Risk Assessment and Mitigation</ListItem>
                    <ListItem>Wax Deposition Assessment and Management</ListItem>
                    <ListItem>Thermal and Hydraulic Performance Evaluation</ListItem>
                    <ListItem>Water and Gas Injection System Analysis</ListItem>
                    <ListItem>Production System Modeling and Optimization</ListItem>


                  </UnorderedList>
                

                

                
                </Text>

              </Flex>
              <Waypoint
                onEnter={() =>
                (document.querySelector("#animate5").style.animation =
                  "fadeUp 1.5s")
                }
              >


                <Flex
                  id="animate5"
                  h={"460px"}
                  mt={{base:"0","3sm":"2rem"}}
                  bgImage={`url(${welcome2})`}
                  backgroundPosition="center"
                  backgroundSize={{ base: "contain", md: "cover" }}
                  backgroundRepeat="no-repeat"
                  justify={"center"}
                  alignItems={"center"}
                  borderRadius="xl"
                  boxShadow={"0 0 10px 10px rgba(0,0,0,0.2)"}
                  flex={{
                    base: "0 1 150px",
                    "2sm": "0 1 190px",
                    "3sm": "0 1 400px",
                    md: "0 1 60%",
                    lg: "0 1 60%",
                  }}
                ></Flex>

              </Waypoint>

            </Flex>



            <Flex
              fontSize={"2rem"}
              flexDirection={"column"}
              mt={"2rem"}
              width={"100%"}
            >
              <Flex flexDirection={{ base: "column-reverse", md: "row" }}>
                <Flex
                  pt={{ base: "4rem", md: "2rem" }}
                  flex={{ base: "0 1 50%" }}
                  flexDirection={"column"}
                  alignItems={{ base: "flex-start", md: "flex-start" }}
                  textAlign={{ base: "left", md: "left" }}
                >



                  <Flex
                    mb={"1.5rem"}
                    overflow={"hidden"}
                    pos={"relative"}
                    width={"fit-content"}
                  >

                    <Waypoint
                      onEnter={() =>
                      (document.querySelector("#animate6").style.animation =
                        "heading 1.5s ")
                      }
                    >
                      <Flex id="animate6">
                        <Heading
                          flexShrink={"0"}
                          textTransform={"uppercase"}
                          fontSize={{ base: "2.5rem", "3sm": "3.0rem" }}
                          w={"100%"}
                          textAlign={"center"}
                          pos="relative"
                        >
                          Area of Expertise
                        </Heading>

                        <Box flexShrink={"0"} bg={"black"} w={"100%"}></Box>
                      </Flex>
                    </Waypoint>
                  </Flex>
                  <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"1.5rem"}></Box>
                  <Text fontSize={{ base: "1.8rem", xl: "2rem" }} maxW={{base:"100%", md:"80%", lg:"80%"}}>


<Box as="span"  fontWeight="bold" fontSize={{ base: "2.0rem", "3sm": "2.2rem" }}>
                  Flow Assurance
                </Box>
                    <UnorderedList>
                      <ListItem>Flow Assurance Studies (Steady-State & Transient)</ListItem>
                      <ListItem>Multiphase Pipeline Hydraulic Analysis</ListItem>
                       <ListItem>Production System Modeling & Optimization</ListItem>
                      <ListItem>Hydraulic and Surge Analysis</ListItem>
                      <ListItem>Hydrate and Wax Management Studies</ListItem>
                       <ListItem>Water and Gas Injection System Studies</ListItem>
                      </UnorderedList>
                      
<Box as="span"  fontWeight="bold"  fontSize={{ base: "2.0rem", "3sm": "2.2rem" }}>
                 Process Engineering Support
                </Box>
                      <UnorderedList>
                      <ListItem>Conceptual Engineering Studies</ListItem>
                        <ListItem>FEED Support Studies</ListItem>
                         <ListItem>Process Simulation </ListItem>
                      <ListItem>Relief & Flare Studies</ListItem>
                      <ListItem>Utility & Water Network Analysis</ListItem>
                    </UnorderedList>
                  </Text>
                  <Waypoint
                    onEnter={() =>
                    (document.querySelector("#animate7").style.animation =
                      "fadeUp 1.5s")
                    }
                  >
                    <NavLink to={{ pathname: "/contact" }}>
                      <Button
                        id="animate7"
                        bg={"#EA0F0F"}
                        color={"whiteAlpha.900"}
                        borderRadius={"md"}
                        mt={"2rem"}
                        fontSize="2rem"
                        fontWeight={700}
                        p={"2.0rem 3rem"}
                        textTransform={"uppercase"}
                        outline={"3px solid #fa0505ee"}
                        outlineOffset={"5px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          outlineOffset: "0px",
                        }}
                      >
                        Contact Us
                      </Button>
                    </NavLink>
                  </Waypoint>
                </Flex>
                <Waypoint
                  onEnter={() =>
                  (document.querySelector("#animate8").style.animation =
                    "fadeUp 1.5s")
                  }
                >

 
                  <Flex
                    id="animate8"
                   
                     height={"450px"}
             
                    mt={"3rem"}
                    bgImage={`url(${welcome3})`}
                    backgroundPosition="center"
                    backgroundSize={{ base: "contain", md: "cover" }}
                    backgroundRepeat="no-repeat"
                    justify={"center"}
                    alignItems={"center"}
                    
                    borderRadius="xl"
                    boxShadow={"0 0 10px 10px rgba(0,0,0,0.2)"}
                    flex={{
                      base: "0 1 150px",
                      "2sm": "0 1 190px",
                      "3sm": "0 1 400px",
                      md: "0 1 60%",
                      lg: "0 1 60%",
                    }}
                  ></Flex>
                </Waypoint>

              </Flex>
 <Text fontWeight="bold" mt={"2rem"} fontSize={{ base: "2.5rem", "3sm": "3.0rem" }}>SOFTWARE TOOLS</Text>
                                <Text fontSize={{base:"1.8rem", md:"2.5rem"}}color="gray.900">
                  


                  OLGA | PIPESIM | PIPENET | HYSYS| PVTSim
</Text>

            </Flex>


          </Flex>

        </Flex>

      </Flex>







      {/* Next Section */}
      <Flex
        width="100vw"
        alignItems={"center"}
        flexDirection={"column"}
        py={"8rem"}
        bg={"#F5F5F5"}
      // bg={"#F0F0F0"}
      >
        <Flex
          mb={"1.5rem"}
          overflow={"hidden"}
          pos={"relative"}
          width={"fit-content"}
        >
          <Waypoint
            onEnter={() =>
            (document.querySelector("#animate9").style.animation =
              "heading 1.5s ")
            }
          >
            <Flex id="animate9">
              <Heading
                textTransform={"uppercase"}
                fontSize={{ base: "3rem", "3sm": "3.5rem", lg: "3.5rem" }}
                fontFamily={"Roboto Condensed, Lato, sans-serif"}
                textAlign="center"
                flexShrink={0}
                w={"100%"}
                px={"2rem"}
              >
                Our Service
              </Heading>
              <Box flexShrink={0} bg={"black"} height={"100%"} w={"100%"}></Box>
            </Flex>
          </Waypoint>
        </Flex>
        <Box
          zIndex={"10"}
          bg={"#EA0F0F"}
          h="5px"
          w={"10rem"}
          mb={"7rem"}
          mt={"1rem"}
        ></Box>

        <Waypoint
          onEnter={() =>
          (document.querySelector("#animate10").style.animation =
            "fadeUp 1.5s")
          }
        >
          <Flex
            id="animate10"
            flexWrap={"wrap"}
            justifyContent="space-evenly"
            gap={"2rem"}
            maxW={"1440px"}
            px="2rem"
          >
            {AreasOfWork.map((area, index) => (
              <Flex
                key={index}
                flex={"1"}
                mb="2rem"
                py={"2rem"}
                borderRadius={"5px"}
                alignItems={"center"}
                flexDirection={"column"}
                _hover={{
                  transform: "scale(1.03)",
                  boxShadow: "0 0 5px 5px rgba(0,0,0,0.08)",
                }}
                transition={"all 0.3s ease-in-out"}
              >
                <Box
                  bgImage={area.image}
                  height={{ base: "300px", md: "200px", "lg": "300px" }}
                  w={{ base: "350px", md: "225px", "lg": "450px" }}
                  backgroundPosition="center"
                  backgroundSize={"cover"}
                  borderRadius="xl"
                ></Box>
                <Heading
                  textAlign={"center"}
                  textTransform={"uppercase"}
                  mt={"2rem"}
                >
                  {area.name}
                </Heading>
                <Link
                  key={index}
                  to={{ pathname: area.url }}
                  state={{ id: area.id }}
                >
                  <Text
                    mt={"1rem"}
                    cursor={"pointer"}
                    fontWeight={"700"}
                    fontSize={"1.7rem"}
                    color={"#EA0F0F"}
                  >
                    Know More
                  </Text>
                </Link>
              </Flex>
            ))}
          </Flex>
        </Waypoint>
      </Flex>
      <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.2rem", md: "2.5rem" }}
        >
          Connect with us
        </Heading>
        
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>

<a
            id="phone"
            style={{ flex: "0 0 22%" }}
            href="https://wa.me/+971501232838"
          >
            
              <Heading fontSize={"4rem"}>
                <i
                  className="fa-brands fa-square-whatsapp"
                  style={{ color: "green" }}
                />
              </Heading>
              
              
            
          </a>


            <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Home;
